var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBulkActionBarEditLabel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bulk_action_bar_edit_label_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.253 3.893a1.33 1.33 0 0 0-1.086-.56l-7.334.007C3.1 3.34 2.5 3.933 2.5 4.666v6.667c0 .733.6 1.327 1.333 1.327l7.334.006c.446 0 .846-.22 1.086-.56L15.167 8zm-1.086 7.44H3.833V4.666h7.334L13.533 8z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bulk_action_bar_edit_label_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h16v16H.5z"
})))));
export default SvgBulkActionBarEditLabel;